<div class="lg:hidden">
    <div class="layout-sidebar">
        <app-menu></app-menu>
    </div>
    <div class="layout-mask" (click)="layoutService.onMenuToggle()"></div>
</div>
